import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import EventListingsRoutes from './routes/EventListingsRoutes';

createRoot(document.getElementById('app-mountpoint')).render(
  <BrowserRouter>
    <EventListingsRoutes />
  </BrowserRouter>,
);
